import { forwardRef, type KeyboardEvent, useId } from 'react'
import { Controller, useController } from 'react-hook-form'

import { InputBase } from '@/models/inputBase.ts'
import { CheckboxIndicator } from './CheckboxIndicator'

export interface CheckboxProps extends InputBase {
  label: string
}

export const Checkbox = forwardRef<HTMLSpanElement, CheckboxProps>(
  function ForwardedCheckbox(props, ref) {
    const labelId = useId()

    const { field } = useController({ name: props.name })

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'Space') {
        e.preventDefault()
      }

      if (['NumpadEnter', 'Enter', 'Space'].includes(e.code)) {
        field.onChange(!field.value)
      }
    }

    return (
      <Controller
        name={props.name}
        render={({ field }) => (
          <div
            className="relative inline-flex cursor-pointer items-center gap-2"
            onClick={() => field.onChange(!field.value)}
            onKeyDown={handleKeyDown}
          >
            <CheckboxIndicator
              checked={!!field.value}
              labelledBy={labelId}
              ref={ref}
            />

            <span className="leading-5" id={labelId}>
              {props.label}
            </span>
          </div>
        )}
        rules={props.rules}
      />
    )
  }
)
